import Vue from 'vue'
import Vuex from 'vuex'
import dict from './modules/dict/index'
import user from './modules/user/index'
import index from './modules/index/index'
import onlineIndex from './modules/online/index'
import org from './modules/org/index'
import collect from './modules/my/collect'
import material from './modules/my/material'
import relation from './modules/my/relation'
import guide from './modules/guide/index'
import bid from './modules/my/bid'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    dict,
    user,
    index,
    onlineIndex,
    org,
    collect,
    material,
    relation,
    guide,
    bid
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js